import Tooltip from "@mui/material/Tooltip";

import { Edit, MoreVert, Preview } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState, useEffect, useRef } from "react";
import Typography from "@mui/material/Typography";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { useDispatch } from "react-redux";

const MoreAction = ({
  params,
  viewClickHandler,
  modifyClickHandler,
  viewRef,
  modifyRef,
}) => {
  const options = ["View", "Modify"];
  const dispatch = useDispatch();
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event && event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    window.addEventListener("keyup", onKeyPressEventHandler);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "moreAction",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      handleClose();
      switch (charCode) {
        case "e":
          viewRef.current.click();
          break;
        case "m":
          modifyRef.current.click();
          break;
        default:
          break;
      }
    }
  };
  const handleIconClick = (value, params) => {
    handleClose();
    switch (value) {
      case "View":
        viewClickHandler(params);
        break;
      case "Modify":
        modifyClickHandler(params);
        break;
    }
  };
  return (
    <>
      <Tooltip title="More Actions">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleMenuClick}
        >
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "100px",
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            ref={option === "View" ? viewRef : modifyRef}
            onClick={() => handleIconClick(option, params)}
          >
            <IconButton
              size="small"
              sx={{
                color: "#004A92",
                display: "flex",
                gap: "5px",
                padding: 0,
              }}
            >
              {(() => {
                switch (index) {
                  case 0:
                    return (
                      <>
                        <Preview fontSize="small" />
                        <Tooltip title="Ctrl+E" placement="right">
                          <Typography
                            variant="inherit"
                            component="div"
                            fontSize="14px"
                            fontWeight="inherit"
                            sx={{ color: "#004A92", fontWeight: "520" }}
                          >
                            {option}
                          </Typography>
                        </Tooltip>
                      </>
                    );
                  case 1:
                    return (
                      <>
                        <Edit fontSize="small" color="inherit" />
                        <Tooltip title="Ctrl+M" placement="right">
                          <Typography
                            variant="inherit"
                            component="div"
                            fontSize="14px"
                            fontWeight="inherit"
                            sx={{ color: "#004A92", fontWeight: "520" }}
                          >
                            {option}
                          </Typography>
                        </Tooltip>
                      </>
                    );
                  default:
                    return;
                }
              })()}
            </IconButton>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MoreAction;
